import React from 'react';
import classNames from 'classnames/bind';
import { useSwiperSlide } from 'swiper/react';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../../utils";
import { Image } from "../../Image";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _CarouselSlide = function _CarouselSlide(_ref) {
  var children = _ref.children,
    activeBgColor = _ref.activeBgColor,
    activeBgImgSrc = _ref.activeBgImgSrc,
    bgColor = _ref.bgColor,
    bgImgSrc = _ref.bgImgSrc,
    bgPosition = _ref.bgPosition,
    bgSize = _ref.bgSize;
  var swiperSlide = useSwiperSlide();
  var isActive = swiperSlide.isActive;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('slide', {
      'slide-active': isActive
    }),
    "data-t-id": "Carousel-CarouselSlide"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('card', {
      'card-active': isActive
    })
  }, /*#__PURE__*/React.createElement(Image, {
    bgColor: isActive ? activeBgColor : bgColor,
    borderRadius: "24px",
    className: cx('card-background'),
    isBackground: true,
    position: bgPosition,
    size: bgSize,
    src: isActive ? activeBgImgSrc : bgImgSrc
  }, children)));
};
export var CarouselSlide = compose(enhancedConnect(), withAutoMetric.Item(function () {
  return {
    name: 'CarouselSlide'
  };
}))(_CarouselSlide);